
<template>

	<div :style="level > 0 ? 'padding-left: 5px; border-left: 5px solid ' + ( level > colors.length - 1 ? 'gray' : colors[level] ) : ''">

		<b-button v-if="type != 'Без изменений' && type != 'Очистить атрибут' && type != '+ Добавить'" size="sm" variant="light" class="filter-button" v-on:click="() => clear()"><b-icon-trash/></b-button>

		<b-dropdown v-if="type == 'Без изменений' || type == 'Очистить атрибут' || type == '+ Добавить'" dropdown :disabled="disabled" variant="outline-primary" no-caret :text="type" size="sm">

			<b-dropdown-item v-if="! first_stage && ! in_doing" v-on:click="() => set_type('Без изменений')">Без изменений</b-dropdown-item>
			<b-dropdown-item v-if="attr_type" v-on:click="() => set_type('Условие')">Условие</b-dropdown-item>
			<b-dropdown-item v-if="attr_type" v-on:click="() => set_type('Действие')">Действие</b-dropdown-item>
			<b-dropdown-item v-if="has_empty && attr_type && ! in_doing" v-on:click="() => set_type('Очистить атрибут')">Очистить атрибут</b-dropdown-item>

		</b-dropdown>

		<b-row align-v="center">

			<b-col>

				<branch v-if="type == 'Условие'" :level="level" ref="branch" :attrs="attrs" :attr_type="attr_type" :attr_reference="attr_reference" nested :in_doing="in_doing" v-on:need_check="need_check" :is_correction="is_correction" :is_correction_mult="is_correction_mult" />
				<doing v-else-if="type == 'Действие'" :level="level" ref="doing" :attrs_base="attrs" :attr_type="attr_type" :attr_reference="attr_reference" :in_doing="in_doing" v-on:need_check="need_check" :is_correction="is_correction" :is_correction_mult="is_correction_mult" />

			</b-col>

		</b-row>

	</div>

</template>

<script>

import branch from "./branch"
import doing from "./doing"

export default
{
	name : "stage",

	props :
	{
		attrs : Array,
		attr_type : String,
		attr_reference : Object,
		level : { type : Number, default : () => 0 },
		disabled : Boolean,
		in_doing : Boolean,
		first_stage : { type : Boolean, default : () => false },
		has_empty : { type : Boolean, default : () => true },
		is_correction : { type : Boolean, default : () => false },
		is_correction_mult : { type : Boolean, default : () => false },
	},

	components :
	{
		branch,
		doing,
	},

	data()
	{
		return {

			type : ( this.first_stage || this.in_doing ) ? "+ Добавить" : "Без изменений",
			colors : [ "red", "green", "blue", "yellow", "orange", "violet" ],

		}
	},

	watch :
	{
	},

	mounted()
	{
	},

	methods :
	{
		need_check()
		{
			this.$emit("need_check")
		},

		clear()
		{
			const new_type = ( this.first_stage || this.in_doing ) ? "+ Добавить" : "Без изменений"

			this.set_type(new_type)
		},

		set_type(new_type)
		{
			this.type = new_type

			this.need_check()
		},

		get()
		{
			var desc = { type : this.type }

			if(this.type == "Условие")
				desc.branch = this.$refs.branch.get()
			else if(this.type == "Действие")
				desc.doing = this.$refs.doing.get()
			else if(this.in_doing)
				throw "Пустое действие"

			return desc
		},

		load(desc)
		{
			this.type = desc.type

			this.$nextTick(
				() =>
				{
					if(desc.type == "Условие")
						this.$refs.branch.load(desc.branch)
					else if(desc.type == "Действие")
						this.$refs.doing.load(desc.doing)
				})
		},
	}
}

</script>

